<div *ngIf="updateDetected" class="sw-update-prompt">
  <span>Update detected. <span (click)="reloadPage()" class="fakelink">Click here to reload</span>.</span>
</div>
